import { useMutation } from '@tanstack/react-query';
import { updateOfficeInfo, type IUpdateOfficeInfoApiPayload } from '~/domain/UpdateOffice';
import { applyOfficePatch } from '../payloads/buildOfficePatch';
import { useApplyLocationUpdate } from './useApplyLocationUpdate';

/**
 * `PATCH /users` for one location, with that location's `x-office` whatever the
 * switcher has selected. The section dialog owns the error and stays open.
 */
export const useUpdateLocation = (officeId: string) => {
  const applyUpdate = useApplyLocationUpdate(officeId);

  return useMutation<unknown, unknown, IUpdateOfficeInfoApiPayload>({
    mutationFn: (patch) => updateOfficeInfo(patch, { officeId }),
    onSuccess: (_response, patch) => applyUpdate((office) => applyOfficePatch(office, patch)),
    meta: { skipGlobalErrorToaster: true },
  });
};
